
import { defineComponent, PropType, reactive } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useIndustryModule } from '@/modules/industries'

export default defineComponent({
    name: 'delete-industry-dialog',
    props: {
        industryId: {
            type: String,
            required: true
        },
        industryName: {
            type: String,
            required: true
        },
        onDeletedCallback: {
            type: Function as PropType<() => Promise<void>>
        }
    },
    emits: [...useDialogPluginComponent.emits],
    setup (props) {
        const $q = useQuasar()
        const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent()
        const { getIndustryOrganizations, deleteIndustry } = useIndustryModule()
        const associatedOrganizations = reactive({
            organizationsChecked: false,
            count: 0
        })

        getIndustryOrganizations(props.industryId)
            .then(organizations => {
                associatedOrganizations.count = organizations.length
                associatedOrganizations.organizationsChecked = true
            })

        function readyToProceed (): boolean {
            return associatedOrganizations.organizationsChecked === true
        }

        async function onDialogOk () {
            await deleteIndustry(props.industryId)
            $q.notify({
                color: 'positive',
                message: 'Industry has been deleted'
            })
            if (props.onDeletedCallback) {
                await props.onDeletedCallback()
            }
        }

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            onDialogOk,
            readyToProceed,
            associatedOrganizations
        }
    }
})
